import React, { useState } from "react"
import containerClasses from "../../styles/container.module.css"
import elizabethCircular from "../../assets/images/elizabeth-circular-5.png"
import tabsStyles from "../../styles/tabs.module.css"

type SafetyLogo = {
  image: string
  alt: string
  role: string
  name: string
}

type TabProps = {
  tabs: Array<{ id: number; title: string; content: string }>
  safetyLogos?: SafetyLogo[]
  pageType?: string
}

export const Tab = ({ tabs, safetyLogos, pageType }: TabProps) => {
  const [activeTab, setActiveTab] = useState(
    tabs.length > 0 ? tabs[0].id : null
  )

  const showLogos = pageType !== "conditions" && safetyLogos && safetyLogos.length > 0

  return (
    <div className="bg-white2">
      <div
        className={`${containerClasses.container} relative py-20 md:py-28 lg:py-32 xl:py-40`}
      >
        <div className="col-span-4 my-0 md:col-span-6 md:col-start-2 lg:col-span-6 lg:col-start-4">
          <h2 className="mb-0 text-center fluid-heading-05">
            Patient <i>Safety</i> Guide
          </h2>
        </div>
        {/* Tab Buttons */}
        <div className="col-span-4 lg:mb-6 md:col-span-8 lg:col-span-12 flex justify-center">
          <div
            className={`sticky inline-flex border-2 border-solid rounded-full ${tabsStyles.safetyTabsButtons} border-blackNew`}
          >
            {tabs.map((tab, index) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`px-6 uppercase sticky py-2 ${
                  tabsStyles.safetyTabsHeading
                } tracking-wide font-semibold transition ${
                  index === 0 ? "rounded-tl-full rounded-bl-full " : ""
                } ${
                  index === tabs.length - 1
                    ? "rounded-tr-full rounded-br-full "
                    : ""
                } ${
                  activeTab === tab.id
                    ? "bg-blackNew text-white active" // Ensure these styles are applied when active
                    : "text-blackNew"
                }`}
              >
                {tab.title}
              </button>
            ))}
          </div>
        </div>
        {/* Tab Content */}
        {tabs.map(tab => (
          <div
            key={tab.id}
            id={`tab.id`}
            className={`${tabsStyles.safetyTabs} ${
              activeTab == tab.id ? "flex" : "hidden"
            } col-span-4 md:col-span-8 flex flex-col border-t-4 lg:col-span-5 lg:col-start-7`}
          >
            <div dangerouslySetInnerHTML={{ __html: tab.content }} />
          </div>
        ))}
        {/* Tabs Image */}
        <div className="relative inline-block h-full col-span-4 md:col-span-8 lg:row-start-3 lg:col-span-5 lg:col-start-1">
          <img
            loading="lazy"
            src={elizabethCircular}
            alt="Dr Elizabeth Hawkes"
            className="w-full lg:pb-0"
          />
          {showLogos && safetyLogos && (
            <div className="absolute right-0 flex items-center h-auto px-6 py-2 bg-white rounded-sm gap-x-4 backdrop-blur-lg bottom-1 md:bottom-8 lg:bottom-12">
              {safetyLogos.map((logo, index) => (
                <React.Fragment key={index}>
                  {index > 0 && (
                    <div className="w-px h-8 bg-gray-300"></div>
                  )}
                  <img
                    className="h-5"
                    loading="lazy"
                    alt={logo.alt}
                    src={logo.image}
                  />
                </React.Fragment>
              ))}
            </div>
          )}
        </div>
        {showLogos && safetyLogos && (
          <div className="col-span-4 px-4 mt-0 leading-snug text-center text-gray-900 lg:col-span-5 lg:col-start-1 md:col-start-2 md:col-span-6 max-w-sm mx-auto lg:max-w-none text-sm">
            <p className="font-bold mb-0">
              {safetyLogos.map((logo, index) => (
                <React.Fragment key={index}>
                  {index > 0 && " · "}
                  {logo.name}, {logo.role}
                </React.Fragment>
              ))}
            </p>
          </div>
        )}
      </div>
    </div>
  )
}
